import Vue from 'vue';
import exchange from './exchange/exchange.vue';
import store from '../common/js/vuex/store';
import exchangeStore from '../applications/exchange/exchange-vuex';
if (!store.hasModule(['exchange'])) {
	store.registerModule('exchange', exchangeStore);
}
Vue.component('exchange', exchange);
